import { render, staticRenderFns } from "./ModalAddProduct.vue?vue&type=template&id=8021edc4&scoped=true"
import script from "./ModalAddProduct.vue?vue&type=script&lang=js"
export * from "./ModalAddProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProduct.vue?vue&type=style&index=0&id=8021edc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8021edc4",
  null
  
)

export default component.exports